import React, { Component } from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import CarrotLG from '../../../assets/images/CarrotLG.svg'

class Question extends Component {
  constructor(props) {
    super(props)

    this.state = {
      expanded: false,
    }
  }

  handleClick = () => {
    if (typeof window !== undefined) {
      this.state.expanded = !this.state.expanded

      this.setState(this.state)
    }
  }

  render() {
    var props = this.props

    return (
      <div
        className={
          styles.questionAnswer +
          ' ' +
          (this.state.expanded ? styles.expanded : ' ')
        }
      >
        <a className={styles.question} onClick={this.handleClick}>
          {props.question}
          <CarrotLG className={styles.carrot} />
        </a>
        <div
          className={styles.answer}
          dangerouslySetInnerHTML={{ __html: props.answer }}
        ></div>
      </div>
    )
  }
}

export default class FAQ extends Component {
  render() {
    var props = this.props

    return (
      <div className="wrapper">
        <div className={styles.container}>
          <h2>{props.title}</h2>
          <div className={styles.questionsContainer}>
            {props.components.map((question, idx) => (
              <Question
                key={idx}
                question={question.title}
                answer={question.subtitle.childMarkdownRemark.html}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
}
